import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z
  .object({
    status: z.string().optional(),
    tripId: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/$locale/preitinerary')({
  validateSearch: searchSchema,
});
